import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../Css/list.css'
import IndiceExplorer from '../Components/indiceExplorer';
import { useAuth } from "../Auth/autoContext";
import { getIndices, getAgendaSemaine } from '../Data/dataApi';
import { getCachedList, saveList } from '../Data/dataCache';  // Importation des fonctions
import AgendaMini from '../Components/agendaMini';
import { toast } from 'react-toastify';
import { Helmet } from "react-helmet-async";


const List: React.FC = () => {
    //  Configuration for using translation with json file
    const { t } = useTranslation();
    const { role } = useAuth();
    const navigate = useNavigate();

    const location = useLocation();
    const hasShown = useRef(false);

    useEffect(() => {
        if (
            location.state?.success === "premium_activated" &&
            !hasShown.current
        ) {
            hasShown.current = true;

            toast.success("🎉 Abonnement Premium activé !");

            navigate(location.pathname, { replace: true });
        }
    }, [location, navigate]);

    return (
        <>
            <Helmet>
                <title>
                    List | Stockifly
                </title>

                <meta
                    name="description"
                    content="List of stocks"
                />
            </Helmet>

            <h1 className='agenda-title'>{t('agenda.title')}</h1>
            {role === 'premium' ? (
                <AgendaMini fetchData={getAgendaSemaine} returnUrl="list" />
            ):
            role === 'public' ? (
                <div className="agenda-upgrade">
                    <p>{t('agenda.accessPremium')} <br /><span>{t('agenda.accessPremiumFree')}</span></p>
                    <button className="button-blue list-button-blue" onClick={() => navigate('/upgradePremium')}>
                        {t('agenda.upgrade')}
                    </button>
                </div>
            ):(
                <div className="agenda-upgrade">
                    <p>{t('agenda.accessPremium')} <br /><span>{t('agenda.accessPremiumFree')}</span></p>
                    <button className="button-blue list-button-blue" onClick={() => navigate('/registerForm')}>
                        {t('agenda.register')}
                    </button>
                    <br />
                    <p>{t('agenda.inscription')}</p>
                </div>
            )}
            <br />
            <h1 className='list-title'>{t('list.title-list')}</h1>
            <IndiceExplorer
                fetchData={getIndices}
                returnUrl="list"
                saveCache={(data, searchTerm, exchangeFilter, sortOrder, page, role) =>
                    saveList(data, searchTerm, exchangeFilter, sortOrder, page, role)
                }
                getCachedData={(searchTerm, exchangeFilter, sortOrder, page, role) =>
                    getCachedList(searchTerm, exchangeFilter, sortOrder, page, role)
                }
/>
        </>
    );
};

export default List;
